// Generated by purs version 0.13.8
"use strict";
var Data_Function = require("../Data.Function/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Show = require("../Data.Show/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var Lunarbox_Data_String = require("../Lunarbox.Data.String/index.js");
var UnusedDeclaration = (function () {
    function UnusedDeclaration(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    UnusedDeclaration.create = function (value0) {
        return function (value1) {
            return new UnusedDeclaration(value0, value1);
        };
    };
    return UnusedDeclaration;
})();
var UnsaturatedFunction = (function () {
    function UnsaturatedFunction(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    UnsaturatedFunction.create = function (value0) {
        return function (value1) {
            return new UnsaturatedFunction(value0, value1);
        };
    };
    return UnsaturatedFunction;
})();
var printError = function (v) {
    return function (v1) {
        if (v1 instanceof UnusedDeclaration) {
            return v.namedWho(Lunarbox_Data_String.doubleShow(Lunarbox_Data_Dataflow_Expression.showVarName)(v1.value1)) + " is declared and never used";
        };
        if (v1 instanceof UnsaturatedFunction) {
            return Data_Show.show(Data_Show.showString)(v.who) + (" doesn't have " + (function () {
                if (v.nth instanceof Data_Maybe.Nothing) {
                    return "all its inputs connected";
                };
                if (v.nth instanceof Data_Maybe.Just) {
                    return " its " + (Lunarbox_Data_String.showIndex(v.nth.value0) + " input connected");
                };
                throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Expression.Lint (line 23, column 8 - line 25, column 71): " + [ v.nth.constructor.name ]);
            })());
        };
        throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Expression.Lint (line 18, column 1 - line 18, column 66): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var lint = (function () {
    var go = function (v) {
        if (v instanceof Lunarbox_Data_Dataflow_Expression.Let && !Lunarbox_Data_Dataflow_Expression.isReferenced(v.value1)(v.value3)) {
            return [ new UnusedDeclaration(v.value0, v.value1) ];
        };
        if (v instanceof Lunarbox_Data_Dataflow_Expression.FunctionCall && v.value2 instanceof Lunarbox_Data_Dataflow_Expression.TypedHole) {
            return [ new UnsaturatedFunction(v.value0, v.value2.value0) ];
        };
        return [  ];
    };
    return Lunarbox_Data_Dataflow_Expression.foldExpression(Data_Monoid.monoidArray)(Data_Function["const"](true))(go);
})();
var getLocation = function (v) {
    if (v instanceof UnusedDeclaration) {
        return v.value0;
    };
    if (v instanceof UnsaturatedFunction) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Expression.Lint (line 28, column 1 - line 28, column 42): " + [ v.constructor.name ]);
};
module.exports = {
    UnusedDeclaration: UnusedDeclaration,
    UnsaturatedFunction: UnsaturatedFunction,
    printError: printError,
    getLocation: getLocation,
    lint: lint
};
